/** Convierte una fecha ISO ("YYYY-MM-DD") al índice de día usado por `activeDays`
 *  (0=lunes … 6=domingo, ver DAY_SHORT_KEYS en data.ts). `Date.getDay()` nativo devuelve
 *  0=domingo…6=sábado; se remapea sumando 6 mod 7. */
export function getMondayFirstDayIndex(isoDate: string): number {
  const jsDay = new Date(`${isoDate}T00:00:00`).getDay();
  return (jsDay + 6) % 7;
}
